import { createFileRoute } from "@tanstack/react-router";
import { sciHead } from "@/lib/science/sci-route";
import { m } from "@/paraglide/messages";
import { CalculatorPage } from "@/tools/scatter-plot/pages/CalculatorPage";

export const Route = createFileRoute("/scatter-plot")({
  ssr: true,
  head: () =>
    sciHead({
      basePath: "/scatter-plot",
      title: m.scatter_meta_title(),
      description: m.scatter_meta_description(),
      toolName: m.scatter_tool_name(),
      faqs: [
        { q: m.scatter_faq_q1(), a: m.scatter_faq_a1() },
        { q: m.scatter_faq_q2(), a: m.scatter_faq_a2() },
        { q: m.scatter_faq_q3(), a: m.scatter_faq_a3() },
        { q: m.scatter_faq_q4(), a: m.scatter_faq_a4() },
      ],
    }),
  component: CalculatorPage,
});
